import React, { useContext } from 'react';
import { SiteContext } from '../../contexts/SiteContext';

export default function GDPR({t}) {
  const { website } = useContext(SiteContext);

  const SITE = website?.title || t('legal.gdpr.fallbackSite', { defaultValue: 'Your Website' });
  const EMAIL = 'info@vbwebb.se';
  const UPDATED = '2025-10-08';

  return (
    <div className="max-w-4xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('legal.gdpr.title')}</h1>
      <p className="text-sm text-gray-500 mb-8">{t('legal.gdpr.lastUpdated', { date: UPDATED })}</p>

      <p className="mb-6">
        {t('legal.gdpr.intro', { site: SITE })}
      </p>

      <section className="space-y-4">
        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.gdpr.controller.title')}</h2>
          <p>
            {t('legal.gdpr.controller.body', { site: SITE })}{' '}
            <a className="text-blue-700 underline" href={`mailto:${EMAIL}`}>{EMAIL}</a>.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.gdpr.collect.title')}</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>{t('legal.gdpr.collect.items.account')}</li>
            <li>{t('legal.gdpr.collect.items.content')}</li>
            <li>{t('legal.gdpr.collect.items.tech')}</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.gdpr.purposes.title')}</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>{t('legal.gdpr.purposes.items.provide')}</li>
            <li>{t('legal.gdpr.purposes.items.support')}</li>
            <li>{t('legal.gdpr.purposes.items.security')}</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.gdpr.retention.title')}</h2>
          <p>{t('legal.gdpr.retention.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.gdpr.recipients.title')}</h2>
          <p>{t('legal.gdpr.recipients.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.gdpr.rights.title')}</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>{t('legal.gdpr.rights.items.access')}</li>
            <li>{t('legal.gdpr.rights.items.rectification')}</li>
            <li>{t('legal.gdpr.rights.items.erasure')}</li>
            <li>{t('legal.gdpr.rights.items.restriction')}</li>
            <li>{t('legal.gdpr.rights.items.objection')}</li>
            <li>{t('legal.gdpr.rights.items.portability')}</li>
            <li>{t('legal.gdpr.rights.items.consent')}</li>
            <li>{t('legal.gdpr.rights.items.complaint')}</li>
          </ul>
          <p className="mt-2">
            {t('legal.gdpr.rights.cta')}{' '}
            <a className="text-blue-700 underline" href={`mailto:${EMAIL}`}>{EMAIL}</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
